export type ActivePriceType = "actual" | "previous" | "selling";

export const PRICE_FIELDS = [
  "cost",
  "actualPrice",
  "previousPrice",
  "sellingPrice",
];

export const cleanNumericValue = (value: any): string => {
  if (value === null || value === undefined || value === "") return "";

  return String(value)
    .replace(/RM/gi, "")
    .replace(/MYR/gi, "")
    .replace(/,/g, "")
    .trim();
};

export const toPriceNumber = (value: any): number => {
  const cleanedValue = cleanNumericValue(value);
  const numberValue = Number(cleanedValue);

  return Number.isFinite(numberValue) ? numberValue : 0;
};

export const calculateProductPrices = (costValue: any) => {
  const cleanedCost = cleanNumericValue(costValue);
  const cost = toPriceNumber(cleanedCost);

  return {
    cleanedCost,
    cost,
    actualPrice: Number((cost * 1.4).toFixed(2)),
    previousPrice: Number((cost * 1.35).toFixed(2)),
    sellingPrice: Number((cost * 1.25).toFixed(2)),
  };
};

export const getActivePriceValue = (product: any): number => {
  if (product.activePrice === "actual") {
    return toPriceNumber(product.actualPrice);
  }

  if (product.activePrice === "previous") {
    return toPriceNumber(product.previousPrice);
  }

  return toPriceNumber(product.sellingPrice);
};

export const isValidActivePrice = (value: any): value is ActivePriceType => {
  return ["actual", "previous", "selling"].includes(value);
};
